import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';
import { errorResponseAtom } from '@components/metrics-panel-hz/atoms';
import { dimensionSelector, filterSelector as trendsFilter } from '@store/noc/trendsData/selectors';
import { filterSelector } from '@store/noc/filtersData/selectors';
import { nocModeSelector } from '@store/noc/base/selectors';
import { isAppModule, NOC_MODE_TRENDS } from '@utils/constants';

function checkRule(rules, errorData) {
  return rules?.some((rule) => rule.some((r) => !!errorData?.[r.field]));
}

export function useDetectError() {
  const errorData = useAtomValue(errorResponseAtom);
  const dimension = useSelector(dimensionSelector);
  const appliedFilter = useSelector(trendsFilter);
  const filters = useSelector(filterSelector);
  const mode = useSelector(nocModeSelector);

  let isError = false;
  const error: {
    dimension: Record<string, boolean>;
    filter: Record<string, boolean>;
  } = {
    dimension: {},
    filter: {},
  };

  if (isAppModule) {
    if (mode === NOC_MODE_TRENDS) {
      const dimensionError = errorData?.[dimension];
      const filterError = checkRule(appliedFilter?.rule, errorData);
      error.dimension[dimension] = !!dimensionError;
      error.filter[appliedFilter?.name] = filterError;
      isError = dimensionError || filterError;
    } else {
      filters.forEach((filter) => {
        const filterError = checkRule(filter.rule, errorData);
        error.filter[filter.name] = filterError;
        if (filterError) {
          isError = true;
        }
      });
    }
  }

  return {
    isError,
    error,
  };
}
